export default __webpack_public_path__ + "media/30-39.d280eac8.svg";